const areasDropdownInit = function () {
	const areasDropdown = document.getElementById('areas-we-cover');

	if (areasDropdown) {
		areasDropdown.addEventListener( 'change', function () {
			window.location = this.value;
		} );
	}
};
export default areasDropdownInit;
